import angular from "angular";
import toastr from 'angular-toastr';
import gettext from 'angular-gettext';

let ResponseInterceptor = function ($q, $injector) {
    /** @ngInclude */

    return {
        responseError: function (response) {
            let toastr = $injector.get('toastr');
            let gettextCatalog = $injector.get('gettextCatalog');
            switch (response.status) {
                case 401:
                    toastr.error(gettextCatalog.getString('You are not logged in!'),
                        gettextCatalog.getString('Authentication Error'));
                    break;
                case 403:
                    toastr.error(gettextCatalog.getString('You are not permitted to view this page.'),
                        gettextCatalog.getString('Permission Error'));
                    break;
                case 406:
                    toastr.error(gettextCatalog.getString('Unsplash Rate Limit Exceeded. Try again later.'),
                        gettextCatalog.getString('Unsplash error'));
                    break;
                case 500:
                    toastr.error(gettextCatalog.getString('There was a problem processing your request. Try again later.'),
                        gettextCatalog.getString('System error'));
                    break;
            }

            return $q.reject(response);
        }
    }

};


export default angular.module('cms.response.interceptor', [toastr, gettext]).factory('ResponseInterceptor', ResponseInterceptor).name;


// WEBPACK FOOTER //
// ./src/cmsCore/Auth/ResponseInterceptor.js